// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2vVqG","vLegacy":"SelectSecondary_vLegacy__2DJUN","error":"SelectSecondary_error__1TLYj","disabled":"SelectSecondary_disabled__30xWh"};